import { render } from "./lefter.vue?vue&type=template&id=389da455&scoped=true"
import script from "./lefter.vue?vue&type=script&lang=js"
export * from "./lefter.vue?vue&type=script&lang=js"

import "./lefter.vue?vue&type=style&index=0&id=389da455&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/workspace/CIS-new-front.rule.vip.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-389da455"]])

export default __exports__